import React, { useState } from 'react';
import LastModeMatchesTable from './LastModeMatchesTable';
import '../styles/MapPerformanceTable.css';

const ModeMatchDropdown = ({
  matches,
  limit,
  onLimitChange,
  mode,
  mapOptions,
  selectedMap,
  onMapChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  const modeLabel =
    mode === 'SND'
      ? 'Search & Destroy'
      : mode === 'CTL'
      ? 'Control'
      : mode;

  const filteredMatches = selectedMap
    ? [...matches]
        .filter((m) => m.Map === selectedMap)
        .sort(
          (a, b) =>
            parseInt(b.ModeID?.split('_').pop()) -
            parseInt(a.ModeID?.split('_').pop())
        )
    : [...matches].sort(
        (a, b) =>
          parseInt(b.ModeID?.split('_').pop()) -
          parseInt(a.ModeID?.split('_').pop())
      );
  const stopControlPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div className="last-games-panel">
      <div
        className={`last-games-header ${expanded ? 'expanded' : ''}`}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="last-games-title">Last {limit} {modeLabel} Games</span>

        <div
          className="last-games-controls"
          onClick={stopControlPropagation}
          onMouseDown={stopControlPropagation}
          onPointerDown={stopControlPropagation}
        >
          <select
            value={selectedMap}
            onChange={(e) => onMapChange(e.target.value)}
            onClick={stopControlPropagation}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
          >
            <option value="">All Maps</option>
            {mapOptions.map((map, idx) => (
              <option key={idx} value={map}>
                {map}
              </option>
            ))}
          </select>

          <select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            onClick={stopControlPropagation}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
          >
            <option value="5">Last 5</option>
            <option value="10">Last 10</option>
            <option value="15">Last 15</option>
            <option value="20">Last 20</option>
          </select>

          <button
            type="button"
            className="last-games-caret"
            onClick={(event) => {
              event.stopPropagation();
              setExpanded(!expanded);
            }}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
            aria-label={`${expanded ? 'Collapse' : 'Expand'} ${modeLabel} games`}
          >
            {expanded ? 'v' : '>'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="last-games-body">
          <LastModeMatchesTable
            data={filteredMatches.slice(0, limit)}
            limit={limit}
            onLimitChange={onLimitChange}
            mode={mode}
          />
        </div>
      )}
    </div>
  );
};

export default ModeMatchDropdown;
